window.slate = window.slate || {};
window.Label = window.Label || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};


/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Label ================*/
Label.getHash = function () {
  return window.location.hash;
};

Label.updateHash = function (hash) {
  window.location.hash = '#' + hash;
  $('#' + hash).attr('tabindex', -1).focus();
};

Label.cacheSelectors = function () {
  Label.cache = {
    // General
    $html                    : $('html'),
    $body                    : $('body'),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $subNav                  : $('.sub-nav'),
    $subSubNav               : $('.sub-sub-nav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess'),

    //Form button
    $lastSubmitButton        : ''
  };
};
Label.globals = function() {
  //nav width
  Label.globals.navWidth = 0;
  $('header .site-nav li').each(function() {
    Label.globals.navWidth = Label.globals.navWidth + $(this).outerWidth();
  });
  Label.isIE8 = false;
  if($('html').hasClass('lt-ie9')) {
    Label.isIE8 = true;
  }
};
Label.drawersInit = function () {
  Label.LeftDrawer = new Label.Drawers('NavDrawer', 'left');
  /*
  Label.RightDrawer = new Label.Drawers('CartDrawer', 'right', {
    {% if settings.ajax_cart_enable %}'onDrawerOpen': ajaxCart.load{% endif %}
  });
  */
};


/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
Label.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

Label.setupFocus = function() {
  document.addEventListener('keydown', function(e) {
    if (e.keyCode === 9) {
      $('body').addClass('show-focus-outlines');
      var $focused = $(document.activeElement);
    }
  });

  document.addEventListener('click', function(e) {
    $('body').removeClass('show-focus-outlines');
  });
};
Label.responsiveVideos = function () {
  $('iframe[src*="youtube.com/embed"]:not(.wrapped)').wrap('<div class="video-wrapper"></div>').addClass("wrapped");
  $('iframe[src*="player.vimeo"]:not(.wrapped)').wrap('<div class="video-wrapper"></div>');
};
Label.loginForms = function() {
  function showRecoverPasswordForm() {
    Label.cache.$recoverPasswordForm.show();
    Label.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    Label.cache.$recoverPasswordForm.hide();
    Label.cache.$customerLoginForm.show();
  }

  Label.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  Label.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (Label.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

Label.resetPasswordSuccess = function() {
  Label.cache.$passwordResetSuccess.show();
};
Label.formCapture = function() {
  $('form.AddToCartForm').on('submit', function(e) { //use on if jQuery 1.7+
      var submitButton = $(this).find('button.AddToCart');
      Label.cache.$lastSubmitButton = submitButton;
  });
};
Label.AddToCartComplete = function() {

  $('.site-header__cart-toggle').addClass("bounce");
   setTimeout(function(){
    $('.site-header__cart-toggle').removeClass('bounce');
  }, 2000);

  setTimeout(function(){
    Label.cache.$lastSubmitButton.removeClass('is-added').blur();
  }, 1000);

  Label.cache.$lastSubmitButton.parents('.cta-content').find('.cta-complete').addClass('visible');
  setTimeout(function(){
    Label.cache.$lastSubmitButton.parents('.cta-content').find('.cta-complete').addClass('show');
  }, 50);
};

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

Label.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productFeaturedImageLink: '[data-product-featured-image-link]',
    productImageGallery: '[data-product-image-gallery]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    productThumbsContainer: '[data-product-single__thumbnails-container]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    Label.cacheSelectors();
    this.$container = $(container);
    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);


    this.$featuredImageLink = $(selectors.productFeaturedImageLink, this.$container);
    $productImageGallery = $(selectors.productImageGallery, this.$container);

    var $productGallery = $productImageGallery.find('.single-product__gallery').modaal({
        type: 'image'
    });

    this.$featuredImageLink.click(function(e) {
      e.preventDefault();
      var $imageID = $(this).data('image-id');
      var $target = '.single-product__gallery--' + $imageID;
      $($target).trigger('click');
    });


    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    //product thumbs
    this.$productThumbs = $(selectors.productThumbs, this.$container);
    this.$productThumbsContainer = $(selectors.productThumbsContainer, this.$container);
    var self = this;
    this.$productThumbs.click(function(e) {
      e.preventDefault();
      self.productThumbnailClick($(this));
    });

  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(Label.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(Label.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(Label.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, Label.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, Label.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      var imageURLBase = sizedImgUrl.replace("_300x300.", "_{width}x.");
      var imageID = variant.featured_image.id;

      this.updateSourceSet(sizedImgUrl, imageURLBase, imageID);
      this.$productThumbs.removeClass('active');
      this.$productThumbsContainer.find('[data-image-id=' + variant.featured_image.id + ']').addClass('active');
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    productThumbnailClick: function(item) {
      item = $(item);
      var sizedImgUrl = item.attr('href');
      var imageURLBase = item.data('image-url-base');
      var imageID = item.data('image-id');

      this.updateSourceSet(sizedImgUrl, imageURLBase, imageID);

      this.$productThumbs.removeClass('active');
      item.addClass('active');

    },

    updateSourceSet: function(sizedImgUrl, imageURLBase, imageID) {
      this.$featuredImageLink.data('image-id', imageID);
      this.$featuredImage.attr('data-srcset', imageURLBase.replace('{width}', '180') + ' 180w, ' +
                                              imageURLBase.replace('{width}', '360') + ' 360w, ' +
                                              imageURLBase.replace('{width}', '590') + ' 590w, ' +
                                              imageURLBase.replace('{width}', '720') + ' 720w, ' +
                                              imageURLBase.replace('{width}', '900') + ' 900w, ' +
                                              imageURLBase.replace('{width}', '1080') + ' 1080w, ' +
                                              imageURLBase.replace('{width}', '1296') + ' 1296w, ' +
                                              imageURLBase.replace('{width}', '1512') + ' 1512w, ' +
                                              imageURLBase.replace('{width}', '1728') + ' 1728w, ' +
                                              imageURLBase.replace('{width}', '2048') + ' 2048w, ');
      this.$featuredImage.removeClass('lazyloaded').addClass('lazyload');
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/**
 * Instagram section Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Instagram section
 *
   * @namespace product
 */

Label.Instagram = (function() {

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Instagram(container) {
    this.$container = $(container);
    //check if we have an access token
    var accessToken = this.$container.attr('data-access-token');
    if(accessToken) {
      this.loadGrams(accessToken);
    }
  }

  Instagram.prototype = $.extend({}, Instagram.prototype, {
    loadGrams: function(accessToken) {
      var _accesstoken = accessToken;
      var _item = this.$container;
      var _container = $(_item).find('.wrapper.grams .grid--full');
      var count = 8;
      var url = "//api.instagram.com/v1/users/self/media/recent?access_token=" + _accesstoken + "&count=" + count;
      $.ajax({
        url: url,
        type: "get",
        dataType: "jsonp",
        success: function(data) {
          for(var i=0; i<count; i++) {
            var thumb = data.data[i].images.thumbnail;
            var lowres = data.data[i].images.low_resolution;
            var highres = data.data[i].images.standard_resolution;
            var permalink = data.data[i].link;
            var gramItem = $(_container).find('.gram-item-blank');
            var caption = '';
            if(data.data[i].caption){
              caption = data.data[i].caption.text;
            }
            var additionalClasses = "";
            if(i > 5) {
              additionalClasses = "xlarge--hide";
            }
            gramItem = gramItem.clone();
            gramItem.appendTo(_container);
            gramItem.removeClass('gram-item-blank').addClass('gram-item ' + additionalClasses);
            gramItem.find('a').attr('href', permalink);
            gramItem.find('a').find('.ratio-box').attr('data-bgset', thumb.url + ' ' + thumb.width + 'w, ' +
                                                    lowres.url + ' ' + lowres.width + 'w, ' +
                                                    highres.url + ' ' + highres.width + 'w, ');
            gramItem.find('a').find('.ratio-box').addClass('lazyload');
          }
        }
      });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Instagram;
})();

/**
 * Tour section Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Tour & Events section
 *
   * @namespace product
 */

Label.Events = (function() {

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Events(container) {
    this.$container = $(container);
    var externalSource = this.$container.attr('data-external-source');
    if(!externalSource) {
      return;
    }

    var max;
    max = this.$container.data('maxevents');

    switch(this.$container.data('source')) {
      case 'tour_songkick':
        var artist_id = this.$container.data('songkick');
        this.songkick(artist_id, max);
        break;
      case 'tour_bandsintown':
        var artist_name = this.$container.data('bandsintown');
        this.bandsInTown(artist_name, max);
        break;
      case 'tour_eventbrite':
        var access_token = this.$container.data('eventbrite');
        this.eventBrite(access_token, max);
        break;
    }
  }

  Events.prototype = $.extend({}, Events.prototype, {

    songkick: function(artist_id, max) {
      var _artistid = artist_id;
      var _max = max;
      var _item = this.$container;
      var _sectionContent = this.$container.find('.wrapper.tour-item-wrapper .section-content');
    	$.getJSON("//api.songkick.com/api/3.0/artists/" + _artistid + "/calendar.json?apikey=aeff44DVdi0z3VT6&jsoncallback=?",
    	function(data){
    		if(data.resultsPage.totalEntries === 0) {
          $(_item).find('.tour-item-no-events').addClass('show');
          $(_item).find('.button-wrapper a.btn').remove();
          return false;
    		}
    		var events = data.resultsPage.results.event;
    		$(events).each(function (i) {
    			if(i == _max){ return false; }
    	    var dateDay = Date.parse( events[i].start.date).toString("dd");
    	    var shortMonth = Date.parse( events[i].start.date).toString("MMM");
    	    var venue = events[i].venue.displayName;
    	    var location = events[i].location.city;
    	    var link = events[i].uri;
    	    var tourItem = $(_item).find('.tour-item-blank');
    	    if(events[i].type == "Festival") {
    		    venue = events[i].displayName;
    	    }
    	    tourItem = tourItem.clone();
    	    tourItem.removeClass('tour-item-blank').addClass('tour-item');
    	    tourItem.appendTo(_sectionContent);
    	    tourItem.find('.date-day').html(dateDay);
    	    tourItem.find('.date-month').html(shortMonth);
    	    tourItem.find('.event-location').html(location);
    	    tourItem.find('.event-venue').html(venue);
    	    tourItem.find('a.ticket-link').attr('href', link);
    		});
    		$(_item).find('.button-wrapper').addClass('show');
        $(_item).find('.button-wrapper a.btn').attr('href','http://www.songkick.com/artists/' + _artistid);
    	});
    },

    bandsInTown: function(artist_name, max) {
      var _artistName = artist_name;
      var _max = max;
      var _item = this.$container;
      var _sectionContent = this.$container.find('.wrapper.tour-item-wrapper .section-content');
      var bandsintownName = _artistName.toLowerCase();
      bandsintownName = bandsintownName.replace(' ','%20');
      var bandsintownSlug = bandsintownName.replace('%20','');
      var url = "//api.bandsintown.com/artists/" + bandsintownName + "/events.json?api_version=2.0&app_id=giraffic_themes";
      $.ajax({
        url: url,
        type: "get",
        dataType: "jsonp",
        success: function(data) {
          var isEmpty = jQuery.isEmptyObject(data);
          if(isEmpty) {
            $(_item).find('.tour-item-no-events').addClass('show');
            $(_item).find('.button-wrapper a.btn').remove();
            return false;
          }
          $(data).each(function (i) {
            if(i == _max){ return false; }
            var dateDay = Date.parse( data[i].datetime).toString("dd");
            var shortMonth = Date.parse( data[i].datetime).toString("MMM");
            var venue = data[i].venue.name;
            var location = data[i].formatted_location;
            var link = data[i].ticket_url;
            var tourItem = $('.tour-item-blank');
            tourItem = tourItem.clone();
            tourItem.removeClass('tour-item-blank').addClass('tour-item');
            tourItem.appendTo(_sectionContent);
            tourItem.find('.date-day').html(dateDay);
            tourItem.find('.date-month').html(shortMonth);
            tourItem.find('.event-location').html(location);
            tourItem.find('.event-venue').html(venue);
            tourItem.find('a.ticket-link').attr('href', link);
          });
          $(_item).find('.button-wrapper').addClass('show');
          $(_item).find('.button-wrapper a.btn').attr('href','http://www.bandsintown.com/' + bandsintownSlug);
        }
      });
    },

    eventBrite: function(access_token, max) {
      var _accessToken = access_token;
      var _max = max;
      var _item = this.$container;
      var _sectionContent = this.$container.find('.wrapper.tour-item-wrapper .section-content');
      var url = "https://www.eventbriteapi.com/v3/users/me/owned_events/?token=" + _accessToken + "&expand=venue&status=live";
      $.ajax({
        url: url,
        type: "get",
        dataType: "json",
        success: function(data) {
          var events = data.events;
          $(events).each(function (i) {
            if(i == _max){ return false; }
            var dateDay = Date.parse( events[i].start.local).toString("dd");
            var shortMonth = Date.parse( events[i].start.local).toString("MMM");
            var name = events[i].name.text;
            var venue = "";
            if (events[i].venue) {
              venue = events[i].venue.name + " &#183; " + events[i].venue.address.city + ", " + events[i].venue.address.country;
            }
            var link = events[i].url;
            var tourItem = $('.tour-item-blank');
            tourItem = tourItem.clone();
            tourItem.removeClass('tour-item-blank').addClass('tour-item');
            tourItem.appendTo(_sectionContent);
            tourItem.find('.date-day').html(dateDay);
            tourItem.find('.date-month').html(shortMonth);
            tourItem.find('.event-location').html(name);
            tourItem.find('.event-venue').html(venue);
            tourItem.find('a.ticket-link').attr('href', link);
          });
        }
      });
    },
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Events;
})();

/**
 * Header section Script
 * ------------------------------------------------------------------------------
 *
   * @namespace header
 */

Label.Header = (function() {


  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Header(container) {
    this.$container = $(container);

    Label.cacheSelectors();
    if(Label.LeftDrawer) {
      Label.LeftDrawer.close();
    }
    Label.LeftDrawer = '';
    Label.RightDrawer = '';
    Label.drawersInit();

    this.init();
    this.subNav();
    this.heroLetterSpacing();
    this.checkNavSize();

    var self = this;
    $(window).bind('resize', function () {
        self.checkNavSize();
    });

  }

  Header.prototype = $.extend({}, Header.prototype, {

    init: function() {
      $('.header_hero-image .arrow').click(function() {
        $('html, body').animate({
          scrollTop: $(".main-content").offset().top
      }, 500);
      });
      if(Label.isIE8) {
        var imgSrc = $('img.ie8-hero-image').data('src');
        $('img.ie8-hero-image').attr('src', imgSrc);
      }
    },

    subNav: function() {

      var $nav = Label.cache.$navigation,
          $subNav = Label.cache.$subNav,
          $subSubNav = Label.cache.$subSubNav,
          $allLinks = $nav.find('a'),
          $topLevel = $nav.children('li').find('a'),
          $parents = $('header'),
          $subMenuLinks = $nav.find('.site-nav__dropdown').find('a');
          activeClass = 'nav-hover';
          focusClass = 'nav-focus';

      // Mouseenter
      $parents.on('click', ".site-nav--has-dropdown", function(evt) {
        var $el = $(this);
        evt.preventDefault();
        if( $(this).hasClass(activeClass) ) {
          $(this).removeClass(activeClass);
          hideDropdown($el);
        } else {
          showDropdown($el);
        }
      });

      //enter when tab is focused
      $parents.find('.site-nav--has-dropdown > a').keydown(function (e) {
       var key = e.which;
       var $el = $(document.activeElement).parents('.site-nav--has-dropdown');
       if(key == 13)  // the enter key code
        {
          e.preventDefault();
          if( $el.hasClass(activeClass) ) {
            $el.removeClass(activeClass);
            hideDropdown($el);
          } else {
            showDropdown($el);
          }
        }
        if (key == 9) { // tab key code
          // call custom function here\
          if(!e.shiftKey) {
            if( $el.hasClass(activeClass) ) {
              e.preventDefault();
              var $list = ".child-list-" + $el.data('list');
              $($list).find('li:first-child > a').focus();
            }
          }
        }
      });

      //child nav tab functions
      $('.child-nav > li > a').keydown(function (e) {
        //get the key and element
        var key = e.which;
        var $el = $(this).parents('li');
        var activeNavItem;

        if (key == 9) {
          //lets see if it's active first
          if($el.hasClass(activeClass)) {
            //e.preventDefault();
          } else {
            //check if first or last child
            if($el.is(':first-child')) {
              if(e.shiftKey) {
                e.preventDefault();
                activeNavItem = $('.site-nav--has-dropdown.nav-hover').find('a');
                $(activeNavItem).focus();

              }
            }
            if ($el.is(':last-child')) {
              if(!e.shiftKey) {
                e.preventDefault();
                activeNavItem = $('.site-nav--has-dropdown.nav-hover');
                var nextItem;
                if(activeNavItem.next().is('li')) {
                    nextItem = activeNavItem.next('li').find('a');
                }
                else {
                    nextItem = $('.header-meta').find('a:visible').first();
                }
                $(nextItem).focus();
              }
            }
          }

        }

      });

      //child child nav tab functions
      $('.child-child-nav > li > a').keydown(function (e) {
        //get the key and element
        var key = e.which;
        var $el = $(this).parents('li');
        var activeParent = $('.child-nav > .site-nav--has-dropdown.nav-hover');
        var activeNavItem;

        if (key == 9) {
          //check if first or last child
          if ($el.is(':last-child') && activeParent.is(':last-child')) {

            if(!e.shiftKey) {
              e.preventDefault();
              activeNavItem = $('.site-nav > .site-nav--has-dropdown.nav-hover');
              var nextItem;
              if(activeNavItem.next().is('li')) {
                  nextItem = activeNavItem.next('li').find('a');
              }
              else {
                  nextItem = $('.header-meta').find('a:visible').first();
              }
              $(nextItem).focus();

            }

          }
        }

      });

      function showDropdown ($el) {
        $subSubNav.removeClass('show');
        var $targetNav = $subNav;
        var $list = ".child-list-" + $el.data('list');

        if($el.hasClass('site-nav--has-dropdown-child')) {
          $el.parents('ul').find('.site-nav--has-dropdown').removeClass(activeClass);
          $targetNav = $subSubNav;
          var tabNo = $el.find('a').attr('tabindex');
          $($list).find('a').each(function (i) {
            $(this).attr('tabindex', tabNo);
          });

        } else {
          $('.site-nav--has-dropdown').attr('aria-expanded', 'false');
          $('.child-nav, .child-child-nav').find('a').removeAttr('tabindex');
          $parents.find('.site-nav--has-dropdown').removeClass(activeClass);

          $($list).find('a').each(function (i) {
            $(this).attr('tabindex', i + 1);
          });
        }

        $el.addClass(activeClass);
        $el.attr('aria-expanded', 'true');
        if($el.find('a').length) {
          $el.find('a').get(0).focus();
        }
        $targetNav.addClass('show');
        $targetNav.find('ul, .sub-nav-search').removeClass('show');
        $targetNav.find($list).addClass('show');

        setTimeout(function() {
          Label.cache.$body.on('touchstart', function() {
            hideDropdown($el);
          });
        }, 250);
        //set tabindex
      }

      function hideDropdown ($el) {
        var $targetNav = $subNav;
        $el.attr('aria-expanded', 'false');
        if($el.hasClass('site-nav--has-dropdown-child')) {
          $('.child-child-nav').find('a').removeAttr('tabindex');
          $targetNav = $subSubNav;
          $subSubNav.removeClass('show');
        } else {
          $subSubNav.removeClass('show');
          $subNav.removeClass('show');
        }

      }

      $(document).mouseup(function (e)
      {
        var container = $('.sub-nav, .site-nav');
        if (!container.is(e.target) &&
            container.has(e.target).length === 0)
        {
          $parents.find('.site-nav--has-dropdown').removeClass("nav-hover");
          //hideDropdown($('.site-nav--has-dropdown'));
          $('.child-child-nav, .child-nav').find('a').attr('tabindex', -1);
          $subSubNav.removeClass('show');
          $subNav.removeClass('show');
        }
      });
    },

    heroLetterSpacing: function() {
      if( $('.header_hero-image').length ) {
        $heroTitle = $('header.hero-active .logo-hero-image .site-header__logo a');
        if( $heroTitle.hasClass('letterspaced')) {
          return;
        }
        $heroTitleText = $heroTitle.text();
        $letterSpacing = $('header.hero-active .logo-hero-image .site-header__logo a').css('letter-spacing');
        if($letterSpacing !== 0) {
          $letterSpacing = parseInt( $letterSpacing.replace("px",""));
        }
        if($letterSpacing > 6) {
          var $words = $heroTitleText.split(" ");
          var $newString = "";
          for (var i = 0; i < $words.length; i++) {
              var $lastChar = $words[i][$words[i].length -1];
              $newString = $newString + $words[i].slice(0,-1) +  "<span>" + $lastChar + "</span> ";
          }
          $heroTitle.html($newString);
          $heroTitle.parents('.text-active').addClass("show");
          $heroTitle.addClass('letterspaced');
        } else {
          $heroTitle.parents('.text-active').addClass("show");
        }
      }
    },

    checkNavSize: function() {
      var totalWidth;
      if( $('header').hasClass('logo-aligned-left')){
        totalWidth = $('header .logo-and-nav').outerWidth();
        var logoWidth = $('header .logo-and-nav .site-header__logo a').outerWidth();
        var navWidth = $('header .site-nav').outerWidth();
        var breakpoint = (totalWidth - logoWidth) - 100;
        if(navWidth > breakpoint) {
          $('header .logo-and-nav, header .header-meta').addClass("break");
        }
        if(navWidth < breakpoint)  {
          $('header .logo-and-nav, header .header-meta').removeClass("break");
        }
      }
      if( $('header').hasClass('nav-aligned-left') ){
        totalWidth = $('header .nav-left-only').outerWidth();
        if(Label.globals.navWidth > (totalWidth - 80) ) {
          $('header .site-nav').addClass("hidden");
          $('header .site-header__burger-menu').addClass("show");
        } else {
          $('header .site-nav').removeClass("hidden");
          $('header .site-header__burger-menu').removeClass("show");
        }
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Header;
})();

/**
 * Sidebar Menu section Script
 * ------------------------------------------------------------------------------
 *
   * @namespace sidebarmenu
 */

Label.SidebarMenu = (function() {


  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function SidebarMenu(container) {
    this.$container = $(container);

    if(Label.LeftDrawer) {
      Label.LeftDrawer.close();
    }
    Label.LeftDrawer = '';
    Label.RightDrawer = '';
    Label.drawersInit();
    Label.cacheSelectors();


    this.mobileNavToggle();
  }

  SidebarMenu.prototype = $.extend({}, SidebarMenu.prototype, {


    mobileNavToggle: function() {
      Label.cache.$mobileSubNavToggle.on('click', function(evt) {
        evt.preventDefault();
        if ($(this).parents('li').attr('aria-expanded')) {
          $(this).parents('li').removeAttr('aria-expanded');
        } else {
          $(this).parents('li').attr('aria-expanded', 'true');
        }
        $(this).parent().toggleClass('drawer-nav--expanded');
      });
    },

    onSelect: function() {
      Label.LeftDrawer.open();
    },

    onDeselect: function() {
      Label.LeftDrawer.close();
    },

    onLoad: function() {
      if(Label.LeftDrawer) {
        Label.LeftDrawer.open();
      }
    },
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return SidebarMenu;
})();

/**
 * Collection section Script
 * ------------------------------------------------------------------------------
 *
   * @namespace Collection
 */

Label.Collection = (function() {


  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Collection(container) {
    this.$container = $(container);

    this.collectionSorting();
    this.collectionViews();

  }

  Collection.prototype = $.extend({}, Collection.prototype, {

    collectionSorting: function() {
      Shopify.queryParams = {};
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }

      var $default = $('#SortBy').data('default');

      $('#SortBy')
        .val($default)
        .bind('change', function() {
          Shopify.queryParams.sort_by = jQuery(this).val();
          location.search = jQuery.param(Shopify.queryParams);
        }
      );

      var collFilters = jQuery('.coll-filter');
      var url = collFilters.data('url');
      var handle = collFilters.data('handle');
      collFilters.change(function() {
        var newTags = [];
        collFilters.each(function() {
          if (jQuery(this).val()) {
            newTags.push(jQuery(this).val());
          }
        });
        if (newTags.length) {
          var query = newTags.join('+');
          window.location.href = handle + '/' + query;
        }
        else {
          window.location.href = url;
        }
      });
    },

    collectionViews: function() {
      if (Label.cache.$changeView.length) {
        Label.cache.$changeView.on('click', function() {
          var view = $(this).data('view'),
              url = document.URL,
              hasParams = url.indexOf('?') > -1;

          if (hasParams) {
            window.location = replaceUrlParam(url, 'view', view);
          } else {
            window.location = url + '?view=' + view;
          }
        });
      }
    },
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Collection;
})();

/**
 * Video section Script
 * ------------------------------------------------------------------------------
 *
   * @namespace Videos
 */

Label.Videos = (function() {


  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Videos(container) {
    this.$container = $(container);

    Label.responsiveVideos();

  }

  return Videos;

})();

/**
 * Slideshow section Script
 * ------------------------------------------------------------------------------
 *
   * @namespace Slideshow
 */

Label.Slideshow = (function() {


  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Slideshow(container) {
    this.$container = $(container);
    var auto_rotate = false;
    if ($(this).attr('data-auto-rotate')) {
      auto_rotate = true;
    }
    var autoplaySpeed = $(this).data('slide-speed');
    var $sectionID = this.$container.data('section-id');
    var arrowsContainer = $('.arrows--' + $sectionID);

    var self = this;

    this.$container.on('init reInit', function(event, slick){
      var $slickPrev = self.$container.find('.slick-prev');
      var $slickNext = self.$container.find('.slick-next');
      $slickPrev.text("");
      arrowsContainer.find('.slick--left-svg').appendTo($slickPrev);
      $slickNext.text("");
      arrowsContainer.find('.slick--next-svg').appendTo($slickNext);
    });


    this.$container.slick({
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: auto_rotate,
      autoplaySpeed: autoplaySpeed
    });
  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {

    onBlockSelect: function(evt) {
      this.$block = $(evt.target);
      this.$index = this.$block.attr('data-slick-index');
      var $slideshow = this.$block.parents('.slideshow');
      $slideshow.slick('slickGoTo', this.$index);
    },
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Slideshow;
})();

/**
 * Maps section Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Instagram section
 *
   * @namespace product
 */

 Label.Maps = (function() {
   var config = {
     zoom: 14
   };
   var apiStatus = null;
   var mapsToLoad = [];

   var errors = {
     addressNoResults:  Label.strings.addressNoResults,
     addressQueryLimit:  Label.strings.addressQueryLimit,
     addressError: Label.strings.addressError,
     authError: Label.strings.authError
   };

   var selectors = {
     section: '[data-section-type="map"]',
     map: '[data-map]',
     mapOverlay: '[data-map-overlay]'
   };

   var classes = {
     mapError: 'map-section--load-error',
     errorMsg: 'map-section__error errors text-center'
   };

   // Global function called by Google on auth errors.
   // Show an auto error message on all map instances.
   // eslint-disable-next-line camelcase, no-unused-vars
   window.gm_authFailure = function() {
     if (!Shopify.designMode) return;

     if (Shopify.designMode) {
       $(selectors.section).addClass(classes.mapError);
       $(selectors.map).remove();
       $(selectors.mapOverlay).after(
         '<div class="' +
           classes.errorMsg +
           '">' +
           Label.strings.authError +
           '</div>'
       );
     }
   };

   function Map(container) {
     this.$container = $(container);
     this.$map = this.$container.find(selectors.map);
     this.key = this.$map.data('api-key');

     if (typeof this.key !== 'string' || this.key === '') {
       return;
     }

     if (apiStatus === 'loaded') {
       var self = this;

       // Check if the script has previously been loaded with this key
       var $script = $('script[src*="' + this.key + '&"]');
       if ($script.length === 0) {
         $.getScript(
           'https://maps.googleapis.com/maps/api/js?key=' + this.key
         ).then(function() {
           apiStatus = 'loaded';
           self.createMap();
         });
       } else {
         this.createMap();
       }
     } else {
       mapsToLoad.push(this);

       if (apiStatus !== 'loading') {
         apiStatus = 'loading';
         if (typeof window.google === 'undefined') {
           $.getScript(
             'https://maps.googleapis.com/maps/api/js?key=' + this.key
           ).then(function() {
             apiStatus = 'loaded';
             initAllMaps();
           });
         }
       }
     }
   }

   function initAllMaps() {
     // API has loaded, load all Map instances in queue
     $.each(mapsToLoad, function(index, instance) {
       instance.createMap();
     });
   }

   function geolocate($map) {
     var deferred = $.Deferred();
     var geocoder = new google.maps.Geocoder();
     var address = $map.data('address-setting');

     geocoder.geocode({ address: address }, function(results, status) {
       if (status !== google.maps.GeocoderStatus.OK) {
         deferred.reject(status);
       }

       deferred.resolve(results);
     });

     return deferred;
   }

   Map.prototype = $.extend({}, Map.prototype, {
     createMap: function() {
       var $map = this.$map;

       return geolocate($map)
         .then(
           function(results) {
             var mapOptions = {
               zoom: config.zoom,
               center: results[0].geometry.location,
               draggable: false,
               clickableIcons: false,
               scrollwheel: false,
               disableDoubleClickZoom: true,
               disableDefaultUI: true
             };


             var styledMapType = new google.maps.StyledMapType(
               [
                 {
                   "elementType": "geometry",
                   "stylers": [
                     {
                       "color": "#f5f5f5"
                     }
                   ]
                 },
                 {
                   "elementType": "labels.icon",
                   "stylers": [
                     {
                       "visibility": "off"
                     }
                   ]
                 },
                 {
                   "elementType": "labels.text.fill",
                   "stylers": [
                     {
                       "color": "#616161"
                     }
                   ]
                 },
                 {
                   "elementType": "labels.text.stroke",
                   "stylers": [
                     {
                       "color": "#f5f5f5"
                     }
                   ]
                 },
                 {
                   "featureType": "administrative.land_parcel",
                   "elementType": "labels.text.fill",
                   "stylers": [
                     {
                       "color": "#bdbdbd"
                     }
                   ]
                 },
                 {
                   "featureType": "poi",
                   "elementType": "geometry",
                   "stylers": [
                     {
                       "color": "#eeeeee"
                     }
                   ]
                 },
                 {
                   "featureType": "poi",
                   "elementType": "labels.text.fill",
                   "stylers": [
                     {
                       "color": "#757575"
                     }
                   ]
                 },
                 {
                   "featureType": "poi.park",
                   "elementType": "geometry",
                   "stylers": [
                     {
                       "color": "#e5e5e5"
                     }
                   ]
                 },
                 {
                   "featureType": "poi.park",
                   "elementType": "labels.text.fill",
                   "stylers": [
                     {
                       "color": "#9e9e9e"
                     }
                   ]
                 },
                 {
                   "featureType": "road",
                   "elementType": "geometry",
                   "stylers": [
                     {
                       "color": "#ffffff"
                     }
                   ]
                 },
                 {
                   "featureType": "road.arterial",
                   "elementType": "labels.text.fill",
                   "stylers": [
                     {
                       "color": "#757575"
                     }
                   ]
                 },
                 {
                   "featureType": "road.highway",
                   "elementType": "geometry",
                   "stylers": [
                     {
                       "color": "#dadada"
                     }
                   ]
                 },
                 {
                   "featureType": "road.highway",
                   "elementType": "labels.text.fill",
                   "stylers": [
                     {
                       "color": "#616161"
                     }
                   ]
                 },
                 {
                   "featureType": "road.local",
                   "elementType": "labels.text.fill",
                   "stylers": [
                     {
                       "color": "#9e9e9e"
                     }
                   ]
                 },
                 {
                   "featureType": "transit.line",
                   "elementType": "geometry",
                   "stylers": [
                     {
                       "color": "#e5e5e5"
                     }
                   ]
                 },
                 {
                   "featureType": "transit.station",
                   "elementType": "geometry",
                   "stylers": [
                     {
                       "color": "#eeeeee"
                     }
                   ]
                 },
                 {
                   "featureType": "water",
                   "elementType": "geometry",
                   "stylers": [
                     {
                       "color": "#c9c9c9"
                     }
                   ]
                 },
                 {
                   "featureType": "water",
                   "elementType": "labels.text.fill",
                   "stylers": [
                     {
                       "color": "#9e9e9e"
                     }
                   ]
                 }
                ],
                  {name: 'Styled Map'});

             var map = (this.map = new google.maps.Map($map[0], mapOptions));
             var center = (this.center = map.getCenter());

             //eslint-disable-next-line no-unused-vars
             var marker = new google.maps.Marker({
               map: map,
               position: map.getCenter()
             });


             //Associate the styled map with the MapTypeId and set it to display.
            map.mapTypes.set('styled_map', styledMapType);
            map.setMapTypeId('styled_map');

             google.maps.event.addDomListener(window, 'resize', function() {
               google.maps.event.trigger(map, 'resize');
               map.setCenter(center);
               $map.removeAttr('style');
             });
           }.bind(this)
         )
         .fail(function() {
           var errorMessage;

           switch (status) {
             case 'ZERO_RESULTS':
               errorMessage = errors.addressNoResults;
               break;
             case 'OVER_QUERY_LIMIT':
               errorMessage = errors.addressQueryLimit;
               break;
             case 'REQUEST_DENIED':
               errorMessage = errors.authError;
               break;
             default:
               errorMessage = errors.addressError;
               break;
           }

           // Show errors only to merchant in the editor.
           if (Shopify.designMode) {
             $map
               .parent()
               .addClass(classes.mapError)
               .html(
                 '<div class="' +
                   classes.errorMsg +
                   '">' +
                   errorMessage +
                   '</div>'
               );
           }
         });
     },

     onUnload: function() {
       if (this.$map.length === 0) {
         return;
       }
       google.maps.event.clearListeners(this.map, 'resize');
     }
   });

   return Map;
 })();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

Label.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

Label.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', Label.Product);
  sections.register('instagram', Label.Instagram);
  sections.register('events', Label.Events);
  sections.register('header', Label.Header);
  sections.register('sidebar-menu', Label.SidebarMenu);
  sections.register('collection', Label.Collection);
  sections.register('slideshow', Label.Slideshow);
  sections.register('video', Label.Videos);
  sections.register('map', Label.Maps);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Label init
  Label.cacheSelectors();
  Label.setupFocus();
  Label.drawersInit();
  Label.responsiveVideos();
  Label.loginForms();
  Label.globals();
  Label.formCapture();


});
